import { Button, Form, Input, message, Image } from "antd";
import React, { useEffect, useState } from "react";
import fourmstyle from "../../styles/fourm.module.scss";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
export function AuthenticatorQrForm(): JSX.Element {
  const [authenticatorQr, setAuthenticatorQr] = useState("");
  const [authenticatorQrForm] = Form.useForm();
  const [authenticatorCode, setAuthenticatorCode] = useState("");
  const [hideQr, setHideQr] = useState(false);
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const onFinish = () => {
    authSVC
      .setAuthenticatorCode({
        authCode: authenticatorCode,
      })
      .then((res: any) => {
        if (res.data.success === true) {
          message.success(res.data.message);
          localStorage.setItem("authenticatorEnable", "true");
          localStorage.setItem("showAuthenticatorQR", "false");
          setTimeout(() => {
            navigate(-1);
          }, 1500);
        } else {
          message.error(res.data.error);
        }
      })
      .catch((err) => {
        console.log(`Error : ${err.message}`);
        message.error(err.message);
      });
  };

  const handleCancel = () => {
    setShowConfirm(false);
    console.log(`Cancelled`);
  };

  const enableDisable2FA = () => {
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    console.log(`Selected to enable`);

    authSVC
      .getAuthenticatorQr()
      .then((resp: any) => {
        if (resp.data.qrcode_url) {
          setAuthenticatorQr(resp.data.qrcode_url);
          setHideQr(true);
          console.log(resp.data.qrcode_url);
        }
      })
      .catch((err) => {
        console.log(`Error : ${err.message}`);
        message.error(err.message);
      });
  };

  return (
    <>
      <Form
        form={authenticatorQrForm}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
        style={{ paddingBottom: "24px", width: "100%" }}
        className="form_wrapper_v2"
      >
        {!hideQr && (
          <Form.Item style={{ marginTop: "30px" }}>
            <Button
              className={fourmstyle.save_button}
              htmlType="button"
              onClick={enableDisable2FA}
            >
              Setup now!
            </Button>
          </Form.Item>
        )}

        {hideQr && (
          <>
            <div
              style={{
                margin: "0 auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Image
                src={authenticatorQr}
                alt="Authenticator Code"
                width={250}
                height={250}
                preview={false}
              />
            </div>

            <Form.Item
              name="authCode"
              rules={[{ required: false, message: "" }]}
            >
              <Input
                placeholder="Enter Authenticator Code"
                onKeyUp={(e) =>
                  setAuthenticatorCode((e.target as HTMLInputElement).value)
                }
              />
            </Form.Item>

            <Form.Item style={{ marginTop: "30px" }}>
              <Button className={fourmstyle.save_button} htmlType="submit">
                Verify
              </Button>
            </Form.Item>
          </>
        )}
      </Form>
      {showConfirm && (
        <div className="backdrop">
          <div className="dialog">
            <p>Are you sure you want to enable 2FA?</p>
            <div className="button_set">
              <button onClick={handleConfirm}>Yes</button>
              <button onClick={handleCancel}>No</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
